import { cn } from '@/lib/utils';
import type { ComponentProps } from 'react';

/** shadcn "Input Group" (ENG-193 attachment) — an input with inline addons
 *  sharing one border. Owned copy, trimmed to what the app uses. */
export function InputGroup({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="input-group"
      role="group"
      className={cn(
        'flex h-8 items-center rounded-md border border-(--color-border) bg-(--color-bg) focus-within:border-(--color-green)',
        className,
      )}
      {...props}
    />
  );
}

export function InputGroupInput({ className, ...props }: ComponentProps<'input'>) {
  return (
    <input
      data-slot="input-group-control"
      className={cn(
        'h-full w-full min-w-0 flex-1 bg-transparent px-2 text-[0.769em] text-(--color-text) outline-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none',
        className,
      )}
      {...props}
    />
  );
}

export function InputGroupAddon({ className, ...props }: ComponentProps<'span'>) {
  return (
    <span
      data-slot="input-group-addon"
      className={cn('shrink-0 select-none pr-2 text-[0.769em] text-(--color-text3)', className)}
      {...props}
    />
  );
}
